import { Box } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { ClientPassportDialog } from "./Passport/ClientPassportDialog";

export function ClientPassportWindowPage() {
    const { id } = useParams();

    // No need for closing functionality since it's in a separate window
    const handleClose = () => {
        window.close();
    };

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100vw",
                padding: 0,
                margin: 0,
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "background.default",
            }}
        >
            <ClientPassportDialog open={true} onClose={handleClose} clientId={id || ""} />
        </Box>
    );
}
